import Vue from 'vue';
import '../styles/bootstrap-4.6.0/css/bootstrap.min.css';
import AheduHeader from './AheduHeader/index.vue';
import AheduTabs from './AheduTabs/index.vue';
import type { AheduTabsItem } from './AheduTabs/AheduTabsItem';
import AheduLTitle from './AheduLTitle/index.vue';
import AheduBTitle from './AheduBTitle/index.vue';
import { Grid as AheduGrid, GridItem as AheduGridItem } from './AheduGrid';
import AheduFooter from './AheduFooter/index.vue';

import {
  AheduUploadModal,
  AheduUpload,
  AheduUploadFileList,
  UploadFile,
  ErrorRender,
} from './AheduUpload';

const components = [
  AheduHeader,
  AheduFooter,
  AheduTabs,

  AheduLTitle,
  AheduBTitle,

  AheduGrid,
  AheduGridItem,

  AheduUploadModal,
  AheduUpload,
  AheduUploadFileList,
];

const install = (_Vue: typeof Vue): void => {
  for (const cpt of components) {
    _Vue.component(cpt.extendOptions.name, cpt);
  }
};

export {
  AheduHeader,
  AheduFooter,
  AheduTabs,
  AheduLTitle,
  AheduBTitle,
  AheduGrid,
  AheduGridItem,
  AheduUploadModal,
  AheduUpload,
  AheduUploadFileList,
  UploadFile,
};

export type { AheduTabsItem, ErrorRender };

export default {
  install,
};
